import { JSX, useMemo, useState } from 'react'
import Account from './AccountStep'
import CompanyInfo from './CompanyInfoStep'
import EmailStep from './EmailStep'
import Form from './Form'
import Confirmation from './ConfirmationStep'

export enum State {
  email,
  companyInfo,
  account,
  confirmation,
}

export type StandardRegisterProps = {
  firstName: string
  lastName: string
  email: string
  password: string
  isAuthenticated: boolean
  organizationNumber: string
  companyName: string
  preRegistrationToken: string | null
  returnUrl: string | null
  cartId: number | null
  disallowNewContacts: boolean
  acceptAccountTerms: boolean
  offersByEmail: boolean
  companyNameSetByOrgNumber: boolean
}

const StandardRegister = (props: StandardRegisterProps) => {
  const [state, setState] = useState<State>(
    !props.isAuthenticated ? State.email : State.companyInfo
  )
  // const { emailGaEvent, companyGaEvent, accountGaEvent } = GaRegEvent()

  const handleStateChange = (stateNext: State) => {
    // switch (state) {
    //   case State.email:
    //     emailGaEvent()
    //     case State.account:
    //     companyGaEvent()
    //     // accountGaEvent()

    // }
    setState(stateNext)
  }

  const onNavigateBack = () => {
    setState(state - 1)
  }

  const content: JSX.Element = useMemo(() => {
    switch (state) {
      case State.email:
        return <EmailStep onNavigateNext={() => handleStateChange(state + 1)} />

      case State.companyInfo:
        return <CompanyInfo onNavigateBack={() => onNavigateBack()} />

      case State.account:
        return <Account onNavigateBack={() => onNavigateBack()} />

      case State.confirmation:
        return <Confirmation />
      default:
        return <></>
    }
  }, [state])

  return (
    <Form onStateChange={handleStateChange} state={state} defaultValues={props} {...props}>
      {content}
    </Form>
  )
}

export default StandardRegister
